export const getResolutionFilters = state => state.resolution.resolutionFilters;

export const getResolutionGridSortCriteria = state => state.resolution.resolutionGridSortCriteria;
